import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ShippingPaid = {
  id: 'shippingPaid',
  type: OptionFormTypes.TYPE_CURRENCY_COMPARISON,
  filterValue: 'ShippingPaid',
  displayName: <FormattedMessage {...messages.shippingPaid} />,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CURRENCY_COMPARISON, criteriaInformations);
  },
};
